import React from 'react';
import { Button, Tooltip, Tag, Badge, Table } from 'antd';
import global from '../../../common/utility/global';

import { VALIDAR_STOCK, LOGISTICA_PRODUCTOS_CON_LOTE } from '../../../common/types/parametroType'
import auth from '../../../common/utility/auth';

export default function GeneralTable(props) {


    const mostrarLoteProducto = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;

    return (
        <Table
            className="table-general"
            dataSource={props.pagination.data}
            scroll={{ x: true }}
            size="small"
            style={{ overflowX: "auto" }}
            onChange={(pagination, filters, sorter) => {
                props.onChange({
                    page: pagination.current,
                    order: sorter.order,
                    field: sorter.field
                })
            }}
            pagination={{
                total: props.pagination.total,
                current: props.pagination.page,
                pageSize: props.pagination.pageSize,
                showTotal: (total) => `${total} Registro(s) encontrado(s).`
            }}
            rowKey={(record) => record.id}
            title={() => (
                <div style={{ width: "100%", textAlign: "right" }}>
                    <div className="custom-options">
                        {props.onExportExcel === undefined ? null : (
                            <Button
                                ghost
                                type="success"
                                icon="file-excel"
                                onClick={props.onExportExcel}
                                style={{ color: "#3fb703" }}
                                loading={props.loadingExcel}
                            >
                                Excel
                            </Button>
                        )}
                    </div>
                </div>
            )}
            columns={[
                {
                    title: 'Código de Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },

                {
                    title: 'Producto',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Unidad de Medida',
                    dataIndex: 'nombreUnidadMedida',
                    key: 'nombreUnidadMedida',
                    sorter: true
                },
                {
                    title: 'Categoria',
                    dataIndex: 'categoria',
                    key: 'categoria',
                    sorter: true
                },
                {
                    title: 'Lote',
                    dataIndex: 'lote',
                    key: 'lote',
                    className: mostrarLoteProducto ? 'show' : 'hide',
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencimiento',
                    key: 'fechaVencimiento',
                    className: mostrarLoteProducto ? 'show' : 'hide',
                    sorter: true
                },
                {
                    title: 'Cantidad Vendida',
                    dataIndex: 'cantidad',
                    key: 'cantidad',
                    sorter: true,
                    align: 'right',
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(3))}</span>
                    )
                },

            ]}
        />
    );

}

